import React from 'react'
import { useSelector } from 'react-redux'

import { DepartmentDetails } from './DepartmentDetails/DepartmentDetails'
import { DepartmentListing } from './DepartmentListing/DepartmentListing'

import { getLocation } from 'ducks/router'

export const Departments = () => {
  const {
    payload: { id },
  } = useSelector(getLocation)

  if (id) {
    return <DepartmentDetails id={id} />
  }

  return <DepartmentListing />
}
